<template>
  <div>
    <b-container fluid class="fp-container bg-light-grey">
      <Tiedot />
    </b-container>
    <b-container class="fp-container bg-white">
      <b-row>
        <b-col cols="12" class="mt-4">
          <h1>Valitse kohteen rakenteet</h1>
          <p v-if="this.userSelection.kayttotarkoitus === null">Nähdäksesi rakenteet <router-link to="/puunkaytonmahdollisuus">määritä ensin hankkeen tiedot</router-link>.</p>
        </b-col>
      </b-row>
      <Rakennetyyppi v-if="this.userSelection.kayttotarkoitus != null" />
    </b-container>
  </div>
</template>

<script>

import Rakennetyyppi from '../components/Rakennetyyppi'
import Tiedot from '../components/Tiedot'
export default {
  name: 'Rakennetyypit',
  components: {Rakennetyyppi, Tiedot},
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Rakennetyypit.vue